import React, { useState, useEffect } from 'react';
import ControllerSection from './ControllerSection.js';
import RoundEdgeButton from './RoundEdgeButton.js';
import LeaveConfirmationPopup from './LeaveConfirmationPopup.js';
import DisplayControllerButtonInfo from './DisplayControllerButtonInfo.js';
import { useUserPresence } from "./useUserPresence";

function ControllerPage({ socket, clientIDRef, playerName, image, inputMsg }) {
    const [showLeavePopupWindow, setLeavePopup] = useState(false);
    const [showControllerInfo, setControlInfo] = useState(false);
    const [lureBtnLabel, setlureBtnLabel] = useState("Lure");
    const { isIdle, isVisible, isActive } = useUserPresence(60000); // 60 sec idle

    useEffect(() => {
        if ((isIdle && isVisible) || !isActive) { window.location.reload(); }
    }, [isIdle, isVisible, isActive]);

    const topPos = 550;
    let controllerUIs =
        <div>
            <div>
                <ControllerSection socket={socket} clientIDRef={clientIDRef} playerName={playerName} image={image} inputMsg={inputMsg} setlureBtnLabel={setlureBtnLabel} />
            </div>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: topPos, left: 0 }}>
                    <RoundEdgeButton onClick={() => { setControlInfo(true); }} variant='roundEdgeInBlack'>&#x2754; </RoundEdgeButton>{/*&#x1F4AC; &#x2139; &#x1F5E8; &#x1F4C4; &#x1F4C2;*/}
                </div>
                <div style={{ position: 'absolute', top: topPos, right: 0 }}>
                    <RoundEdgeButton onClick={() => { setLeavePopup(true); }} variant='roundEdgeInBlack'>&#x21e8;</RoundEdgeButton> {/*&#x2794; &#x1F6AA; &#x1F6BA; &#x1F3D8; &#x1F3E0;*/}
                </div>
            </div>
        </div>
    let content;
    content = (<div>
        {controllerUIs}
        {showLeavePopupWindow === true ? (<LeaveConfirmationPopup showPopup={showLeavePopupWindow} onClose={() => setLeavePopup(false)} />) : null}
        {showControllerInfo === true ? (<DisplayControllerButtonInfo showPopup={showControllerInfo} onClose={() => setControlInfo(false)} image={image} lureBtnLabel={lureBtnLabel} />) : null}
    </div>);
    return (<div>{content}</div>);
};
export default ControllerPage;